import { FocusStyleManager } from "@blueprintjs/core"
import OpenReplay from "@openreplay/tracker"
import { BrowserTracing } from "@sentry/tracing"
import React, { useEffect } from "react"
import ErrorBoundary from "./components/Atoms/ErrorBoundary"
import Host from "./global/host.global"
import ApolloClientProvider from "./services/apollo.service"
import RouterWrapper from "./wrappers/RouterWrapper"
// Style
import * as Sentry from "@sentry/react"
import ReactGA from "services/analytics.service"
import AuthenticationWrapper from "wrappers/AuthenticationWrapper"
import RoutesWrapper from "wrappers/RoutesWrapper"
import "./styles/main.scss"
import useOnline from "hooks/useOnline"
FocusStyleManager.onlyShowFocusOnTabs() // removes the blue outline
export const tracker = new OpenReplay({
  projectKey: "32TpxKkz5p9a9pJJNuUl",
  __DISABLE_SECURE_MODE: process.env.NODE_ENV === "development",
})

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new BrowserTracing()],
    environment: process.env.REACT_APP_ENV,
    release: process.env.REACT_APP_VERSION,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  })
}

// Change-1
const App = () => {
  useEffect(() => {
    if (parseInt(process.env.REACT_APP_USE_OPEN_RELAY)) {
      tracker.start()
    }
  }, [])
  ReactGA.initialize(process.env.REACT_APP_TRACKING_CODE)
  ReactGA.pageview(window.location.pathname + window.location.search)

  const isOnline = useOnline()

  if (!isOnline) {
    return <div>not online</div>
  }
  return (
    <ErrorBoundary>
      <Host>
        <ApolloClientProvider>
          <RouterWrapper>
            <AuthenticationWrapper>
              <RoutesWrapper />
            </AuthenticationWrapper>
          </RouterWrapper>
        </ApolloClientProvider>
      </Host>
    </ErrorBoundary>
  )
}

export default App
